<sn-drawer>
  <sn-drawer-header [title]="'shares.manageShares' | t">
    <sn-drawer-header-actions>
      <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
    </sn-drawer-header-actions>
    <div *ngIf="subheaderText" class="share-drawer-v2__subheader">
      {{ subheaderText }}
    </div>
  </sn-drawer-header>

  <sn-drawer-content *ngIf="shares$ | async as shares">
    <div class="share-drawer-v2__list-header">
      <h3 class="share-drawer-v2__list-title">{{ 'shares.sharedOrganizations' | t }}</h3>
      <span class="share-drawer-v2__list-count">{{ 'shares.organizationsCount' | t: { count: shares.length } }}</span>
    </div>

    <ng-template [ngIf]="shares.length" [ngIfElse]="emptyList">
      <fs-sharing-list-v2 [items]="shares" [shareConfigAction]="shareConfigAction" [shareDeleteAction]="shareDeleteAction"></fs-sharing-list-v2>
    </ng-template>

    <ng-template #emptyList>
      <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
        {{ 'shares.thisItemIsNotShared' | t }}
      </sn-empty-state>
    </ng-template>
  </sn-drawer-content>

  <sn-drawer-footer *ngIf="canAdd">
    <button mat-flat-button color="accent" (click)="addShare()">
      <sn-icon>add</sn-icon>
      {{ 'shares.addOrganization' | t }}
    </button>
  </sn-drawer-footer>
</sn-drawer>

